import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import styles from './Auth.module.css';
import { useContext, useState } from 'react';
import { useParams } from 'react-router-dom';
import SubmitButton from './SubmitButton';
import { toast } from 'react-toastify';
import { Context } from '../../AuthContext';

export default function InviteDialog({
  button,
  updatePeople,
  functionality = '',
  name = '',
  email = '',
  permission = 'Member',
  disabled = false,
}) {
  const [open, setOpen] = React.useState(false);
  const { vertical_id } = useParams();
  const { user } = useContext(Context);
  const [submitting, setSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [formData, setFormData] = useState({
    vertical_id: vertical_id,
    name: name,
    email: email,
    permission: permission,
  });

  const handleClickOpen = () => {
    setFormData({
      vertical_id: vertical_id,
      name: name,
      email: email,
      permission: permission,
    });
    setErrorMessage('');
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    // setErrorMessage('');
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const submitForm = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setErrorMessage('');

    const response = await invite(formData);
    if (response.status == 200 || response.status == 201) {
      updatePeople({
        name: formData.name,
        email: formData.email,
        _id: response.data._id,
        status: 'Invited',
        permission: formData.permission,
        subscription_status: response.data.subscription_status,
      });
      toast.success('Invitation sent successfully!', {
        className: 'toast',
        autoClose: 3000,
      });
      handleClose();
    } else if (response.status === 403 && response.data?.code === 'joined_vertical_limit_reached') {
      setErrorMessage(response.data.message);
    } else {
      toast.error('Unable to invite user! ' + response.data.message, {
        className: 'toast',
        autoClose: 3000,
      });
      handleClose();
    }
    setSubmitting(false);
  };

  const invite = async (formData) => {
    const token = await user.getIdToken();
    let url = process.env.REACT_APP_FLASK_WEBSERVER + 'inviteUser';

    const res = await fetch(url, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    const data = await res.json();

    return {
      status: res.status,
      data: data,
    };
  };

  return (
    <React.Fragment>
      {button &&
        React.cloneElement(button, {
          onClick: disabled ? undefined : handleClickOpen,
          disabled: disabled || button.props.disabled,
        })}
      <form onSubmit={submitForm} style={{ display: 'contents' }}>
        <Dialog
          open={open}
          onClose={handleClose}
          fullWidth={true}
          maxWidth={'md'}
          PaperProps={{
            component: 'form',
          }}
        >
          <DialogTitle
            sx={{ fontSize: '26px', fontWeight: 700, lineHeight: '33.8px', textAlign: 'left' }}
          >
            {functionality === 'edit' ? 'Edit Invitation' : 'Invite New User'}
          </DialogTitle>
          <DialogContent>
            <p className={styles['inviteFormLabel']}>Full Name</p>
            <TextField
              autoFocus={true}
              required
              margin="dense"
              id="name"
              name="name"
              type="text"
              fullWidth
              variant="outlined"
              sx={{ margin: 0, padding: 0 }}
              placeholder="Paul Galleberg"
              value={formData.name}
              onChange={handleChange}
            />

            <p className={styles['inviteFormLabel']}>Email address</p>
            <TextField
              required
              margin="dense"
              id="email"
              name="email"
              type="email"
              fullWidth
              variant="outlined"
              sx={{ margin: 0, padding: 0 }}
              placeholder="paul@gmail.com"
              value={formData.email}
              onChange={handleChange}
              disabled={functionality === 'edit' && true}
            />

            {errorMessage && (
              <p
                style={{
                  color: '#d32f2f',
                  fontSize: '14px',
                  margin: '12px 0 0 0',
                  textAlign: 'left',
                }}
              >
                {errorMessage}
              </p>
            )}
          </DialogContent>
          <DialogActions sx={{ justifyContent: 'left' }}>
            <SubmitButton
              text="Invite"
              disabled={submitting}
              spinSize="lg"
              width="76px"
              height="36px"
              margin="10px"
              fontWeight={700}
              fontSize="16px"
            />
            <Button
              onClick={handleClose}
              type="reset"
              variant="outlined"
              disableRipple={true}
              sx={{ textTransform: 'none', fontWeight: 700, fontSize: '16px' }}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      </form>
    </React.Fragment>
  );
}
